import React from "react";
import { startOfTomorrow, endOfTomorrow } from "date-fns";
import RacesByDay from "@/features/racing/components/RacesByDay";
import type { RouteComponentProps } from "@gatsbyjs/reach-router";

const Tomorrow = (_: RouteComponentProps) => {
  const startDate = startOfTomorrow();
  const endDate = endOfTomorrow();

  return <RacesByDay startDate={startDate} endDate={endDate} />;
};

export { Tomorrow };
